var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalEditB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 24C44 12.96 35.04 4 24 4C12.96 4 4 12.96 4 24C4 35.04 12.96 44 24 44",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H18C14.1 17.68 14.1 30.32 18 42H16",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6C31.94 11.84 32.92 17.92 32.92 24",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 32V30C11.84 31.94 17.92 32.92 24 32.92",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17.9992C17.68 14.0992 30.32 14.0992 42 17.9992",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.42 31.48L31.3399 38.5601C31.0599 38.8401 30.7999 39.36 30.7399 39.74L30.3599 42.44C30.2199 43.42 30.9 44.1 31.88 43.96L34.5799 43.58C34.9599 43.52 35.5 43.26 35.76 42.98L42.8399 35.9001C44.0599 34.6801 44.6399 33.26 42.8399 31.46C41.0599 29.68 39.64 30.26 38.42 31.48Z",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 32.5C37.9999 34.66 39.6799 36.3399 41.8399 36.9399",
    stroke: "#020607",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalEditB);
export default __webpack_public_path__ + "static/media/global-edit-b.4550b9ad50b3354e9dcf4e61b1efe4d7.svg";
export { ForwardRef as ReactComponent };